<template>
    <div class="LeftDisplayPanel">
        <div v-if="isShowDataSaveUI">
            <data-save @closeDataSave="closeDataSave" v-bind:userData="userData" v-bind:saveData="saveData"></data-save>
        </div>
        <div v-if="displayDataType === 'drawModel'" class="container-fluid">
            <div class="row">
                <div v-for="(item, index) in displayData" v-bind:key="index">
                    <div v-if="item.type==='Fly Point'" class="col-sm-12 form-horizontal">
                        <div class="panel panel-primary" v-bind:class="{ on: selectedDataName===item.name }">
                            <div class="panel-heading" v-on:click="switchSelectedData(item.name)">
                                <h3 class="panel-title">
                                    {{item.type}}
                                </h3>
                            </div>
                            <div class="panel-body">
                                <label class="">Point Name:</label>
                                <input type="text" class="form-control" v-model="item.name" disabled>
                            </div>
                            <div class="panel-body">
                                <label class="">Point Time:</label>
                                <input type="text" class="form-control" v-model="item.time" onchange="function(){testFunction(item.name)}">
                            </div>
                            <div class="panel-body">
                                <button class="btn btn-primary" type="button" v-on:click="focusData(item.name)">Focus</button>
                                <button class="btn btn-danger" type="button" v-on:click="removeData(item.name)">Remove</button>
                                <!--<button class="btn btn-primary" type="button" v-on:click="testFunction(item.name)">test</button>-->
                            </div>
                        </div>
                    </div>
                    <div v-if="item.type==='Fly'" class="col-sm-12 form-horizontal">
                        <div class="panel panel-primary">
                            <div class="panel-heading">
                                <h3 class="panel-title">
                                    {{item.type}} : {{item.name}}
                                </h3>
                            </div>
                            <div class="panel-body">
                                <label class="">Start Time:</label>
                                <input type="text" class="form-control" v-model="item.startTime" disabled>
                            </div>
                            <div class="panel-body">
                                <label class="">Stop Time:</label>
                                <input type="text" class="form-control" v-model="item.stopTime" disabled>
                            </div>
                            <div class="panel-body">
                                <button class="btn btn-primary" type="button" v-on:click="focusData(item.name)">Focus</button>
                                <button class="btn btn-success" type="button" v-on:click="saveDataToUser(item.name)">Save</button>
                                <button class="btn btn-danger" type="button" v-on:click="removeData(item.name)">Remove</button>
                            </div>
                        </div>
                    </div>
                     <div v-if="item.type==='Draw_E_Data'" class="col-sm-12 form-horizontal">
                        <div class="panel panel-primary" v-bind:class="{ on: selectedDataName===item.name }">
                            <div class="panel-heading" >
                                <h3 class="panel-title">
                                    {{item.type}}
                                </h3>
                            </div>
                            <div class="panel-body">
                                <label class="">Data Name:</label>
                                <input type="text" class="form-control" v-model="item.name" disabled>
                            </div>
                            <!--<div class="panel-body">
                                <label class="">Point Time:</label>
                                <input type="text" class="form-control" v-model="item.time" onchange="function(){testFunction(item.name)}">
                            </div>-->
                            <div class="panel-body">
                                <button class="btn btn-primary" type="button" v-on:click="focusData(item.name)">Focus</button>
                                <button class="btn btn-danger" type="button" v-on:click="removeData(item.name)">Remove</button>
                                <!--<button class="btn btn-primary" type="button" v-on:click="testFunction(item.name)">test</button>-->
                            </div>
                        </div>
                    </div>
                    <div v-if="item.type==='Draw_P_Data'" class="col-sm-12 form-horizontal">
                        <div class="panel panel-primary" v-bind:class="{ on: selectedDataName===item.name }">
                            <div class="panel-heading" >
                                <h3 class="panel-title">
                                    {{item.type}}
                                </h3>
                            </div>
                            <div class="panel-body">
                                <label class="">Data Name:item.name</label>
                                <input type="text" class="form-control" v-model="item.polygonArea" disabled>
                            </div>
                            <div class="panel-body">
                                <button class="btn btn-primary" type="button" v-on:click="processData(item.name,'Calculation')">Cal</button>
                                <button class="btn btn-danger" type="button" v-on:click="removeData(item.name)">Remove</button>
                                <!--<button class="btn btn-primary" type="button" v-on:click="testFunction(item.name)">test</button>-->
                            </div>
                        </div>
                    </div>
                    <div v-if="item.type==='View Point'" class="col-sm-12 form-horizontal">
                        <div class="panel panel-primary" v-bind:class="{ on: selectedDataName===item.name }">
                            <div class="panel-heading" v-on:click="switchSelectedData(item.name)">
                                <h3 class="panel-title">
                                    {{item.type}}
                                </h3>
                            </div>
                            <div class="panel-body">
                                <label class="">Point Name:</label>
                                <input type="text" class="form-control" v-model="item.name" disabled>
                            </div>
                            <!--<div class="panel-body">
                                <label class="">Point Time:</label>
                                <input type="text" class="form-control" v-model="item.time" onchange="function(){testFunction(item.name)}">
                            </div>-->
                            <div class="panel-body">
                                <button class="btn btn-primary" type="button" v-on:click="focusData(item.name)">Focus</button>
                                <button class="btn btn-danger" type="button" v-on:click="removeData(item.name)">Remove</button>
                                <!--<button class="btn btn-primary" type="button" v-on:click="testFunction(item.name)">test</button>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--<button class="btn btn-primary" type="button" v-on:click="testaFunction()">Update</button>-->
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import DataSave from '@/components/DataSave'
export default {
    name: 'LeftDisplayPanel',
    props: {
        userData: {
            default: '' 
        }
    },
    data () {
    return {
        msg: 'This is left display panel!',
        titleName: 'Save Data',
        isShowDataSaveUI: false,
        displayDataType: "drawModel",
        displayData: [
            /*{
                name: "test name",
                time: "test time"
            }*/
        ],
        saveData: undefined,
        currentSaveDataName: undefined,
        displayDataBackup: [],
        selectedDataName: "",
        area:0.0
    }
    },
    watch: {
        displayData : {
            handler:function(val,oldval){
                if(val.length === this.displayDataBackup.length)
                {
                    for(var i = 0; i < val.length; i++)
                    {
                        if(val[i].time !== this.displayDataBackup[i].time)
                        {
                            this.updateDataTime(val[i]);
                        }  
                    }
                    var tempStr = JSON.stringify(val);
                    this.displayDataBackup = JSON.parse(tempStr);
                    //this.displayDataBackup = this.displayData;
                }else
                {
                    //[ ...this.displayDataBackup ] = this.displayData;
                    var tempStr = JSON.stringify(val);
                    this.displayDataBackup = JSON.parse(tempStr);
                }
            },
            deep:true
        }
    },
    mounted: function() {
        eventBus.$on('addModelPanel', function(data) {
            this.$set(this.displayData,this.displayData.length,data);
            this.$emit('switchBar',true);
        }.bind(this));
         eventBus.$on('addViewPanel', function(data) {
            this.$set(this.displayData,this.displayData.length,data);
            this.$emit('switchBar',true);
        }.bind(this));
        eventBus.$on('removePanel', function() {
            this.displayData = [];
        }.bind(this));
    },
    methods: {
        focusData: function(dataName) {
            pfAirViewer._drawLayerManager.setLayerDataStatus(dataName,"focus");
        },
        processData: function(dataName,processType) {
            if(processType == "Calculation")
            {
                var polygonArea= pfAirViewer._drawLayerManager.getLayerData(dataName).cesiumData["air_CalculatedArea"](); 
                for(var i in this.displayData)
                {
                    if(this.displayData[i].name == dataName)
                    {
                        this.displayData[i].polygonArea = polygonArea;
                        break;
                    }
                }
            }
        },
        removeData: function(dataName) {
            for(var i in this.displayData)
            {
                if(this.displayData[i].name == dataName)
                {
                    this.displayData.splice(i, 1);
                    break;
                }
            }
            pfAirViewer._drawLayerManager.removeLayersData([dataName]);

            pfAirViewer.clock.currentTime = Cesium.JulianDate.now();
            pfAirViewer.clock.clockRange = Cesium.ClockRange.UNBOUNDED;
            //pfAirViewer.clock.stopTime = resaultEntity.availability.stop;
            //pfAirViewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;
        },
        switchSelectedData: function (dataName) {
            if(this.selectedDataName === dataName)
            {
                this.selectedDataName = "";
                pfAirViewer._modelManipulator.setCurrentModel({
                    model : undefined
                });
            }else{
                pfAirViewer._modelManipulator.setCurrentModel({
                    model : pfAirViewer._drawLayerManager._layerData[dataName].cesiumData
                });
                this.selectedDataName = dataName;
            }
        },
        updateDataTime: function(data) {
            var entity = pfAirViewer._drawLayerManager._layerData[data.name];
            //var entity = pfAirViewer._drawLayerManager._layerData[this.displayData[i].name];
            var tempDate = new Date(data.time);
            var startJulianData = Cesium.JulianDate.fromDate(tempDate);

            var stopJulianData = Cesium.JulianDate.clone(startJulianData);
            //make model always availability
            Cesium.JulianDate.addDays(stopJulianData,365*100,stopJulianData);
            var timeInterval = new Cesium.TimeInterval({
                start : startJulianData,
                stop : stopJulianData
            });
            var timeIntervalCollection = new Cesium.TimeIntervalCollection();
            timeIntervalCollection.addInterval(timeInterval);
            entity.cesiumData.availability = timeIntervalCollection;
        },
        testFunction: function(dataName) {
            //console.log(pfAirViewer._drawLayerManager._layerData[dataName].cesiumData.availability);
            console.log("time change");
        },
        saveDataToUser: function(dataName) {
            this.saveData = {
                type: 'fly',
                sourceId: dataName
            };
            this.currentSaveDataName = dataName;
            this.isShowDataSaveUI = true;
        },
        closeDataSave: function(info) {
            /*
            if(info)
            {
                //this.removeData(this.currentSaveDataName);
            }else{

            }*/
            this.isShowDataSaveUI = false;
        }
    },
    components: {
        DataSave
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-body {
    padding: 4px 10px 10px 10px;
}
.col-sm-12 {
    padding-left: 5px;
    padding-right: 15px;
}
.LeftDisplayPanel {
    margin: 5px;
    height: 92%;
    overflow: auto;
}
.on {
    box-shadow: 10px 10px 5px #888888;
}
</style>


// WEBPACK FOOTER //
// src/components/LeftDisplayPanel.vue